import React, { useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useTable, useExpanded, useFilters, usePagination , useColumnOrder } from "react-table";
import SubTable from "./SubTable";
import Pagination from "./Pagination";
import { Spinner } from "react-bootstrap";
const DataTable = ({
  lang,
  pageClass,
  columns,
  dataTable,
  // subColumns,
  subDataKey,
  loader,
  search,
}) => {

  const langData = require(`../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { expanded },
    setFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: dataTable,
      initialState: {
        hiddenColumns: ["filterId" , "filterContainerNumber"],
      }
    },
    useColumnOrder,
    useExpanded,
    useFilters,
    usePagination
  );

  useEffect(() => {
    if (search) setFilter(search.type, search.value);
  }, [search]);

  if (loader) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  return (
    <>
      <Table {...getTableProps()}>
        <thead className={`${pageClass}-table-table-head`}>
          {headerGroups.map((headerGroup, index) => (
            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th key={index} {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody
          className={`${pageClass}-table-table-body`}
          {...getTableBodyProps()}
        >
          {page.map((row, index) => {
            prepareRow(row);
            
            return (
              <>
                <tr key={index} {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td key={index} {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>

                {/* {row.isExpanded ? (
                  <tr>
                    <td colSpan={visibleColumns.length}>
                      <SubTable
                        langData={langData}
                        pageClass={pageClass}
                        // subColumns={subColumns}
                        subDataIndex={row['original']}
                        subDataKey={subDataKey}
                      />
                    </td>
                  </tr>
                ) : null} */}
              </>
            );
          })}
        </tbody>
      </Table>
      <Pagination
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageOptions={pageOptions}
        pageCount={pageCount}
        gotoPage={gotoPage}
        nextPage={nextPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
        pageIndex={pageIndex}
        pageSize={pageSize}
      />
    </>
  );
};

export default DataTable;
